<template>
  <a-card v-if="getScreen">
    <span slot="title">UM PP Usage Report Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Usage" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
        <a-button v-if="current == (steps.length - 1)" type="default" :loading="btnLoading" @click="savemobile"
          :disabled="dataList.length <= 1">{{ status === false ? "Save Draft" : "Save" }}</a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :span="leftcolumn" class="m-page-wrapper">
      <a-card :loading="loading" class="m-height-full m-display-flex flex-column">
        <span slot="title">
          <a-tag slot="extra">{{ mode }}</a-tag>UM PP Usage Report Form
        </span>
        <a-steps :current="current" status="process">
          <a-step title="Informasi" />
          <a-step title="Pemakaian" />
          <a-step title="Approval" />
        </a-steps>
        <div class="steps-content flex-1">
          <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button-group>
              <a-button v-if="current == 1" type="primary" @click="handleNew" :loading="loadingAdd">Add</a-button>
              <a-button v-if="current < steps.length - 1" type="default" @click="next">Next</a-button>
              <a-button v-if="type != 'revised' && current == (steps.length - 1)" :disabled="disableSaveButton"
                type="default" :loading="btnLoading" @click="saveDraft">Save Draft</a-button>
              <a-button v-if="current == (steps.length - 1)" type="primary" :loading="btnLoading"
                :disabled="disableSaveButton" @click="save">Save</a-button>
            </a-button-group>
            <a-button v-if="current > 0" @click="prev">Previous</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <a-col :span="rightcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex flex-column">
        <div slot="title">
          <span>Reporting Details</span>
        </div>
        <template slot="extra">
          <a-button :loading="collectiveLoading" @click="onCollective" class="margin-right-small"
            icon="edit">Collective</a-button>
          <a-button @click="handleExpand()">
            <span>{{ labelExpand }}</span>
          </a-button>
        </template>
        <a-table :columns="columns" :dataSource="getCountWeb" :pagination="pagination" size="small" :scroll="{ x: 750 }"
          bordered>
          <template slot="customTitle">
            {{this.isCollective ? "Check" : "Action"}}
          </template>
          <template slot="deskripsi" slot-scope="index, item">
            <h4 class="margin-remove">{{ item.deskripsi }}</h4>
            <a-alert type="error" banner v-if="item.edit_hapus != '0' && item.kredit != '' && (item.item_um == null
              || item.item_um == '')" message="item name cannot be empty!" />
            <small>{{ item.item_um }}</small>
          </template>
          <template slot="commission" slot-scope="index, item">
            <span v-if="item.iscommision == '1'">
                Yes
              </span>
              <span v-else>
                No
              </span>
          </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="operation" slot-scope="index, item">
            <a-button-group v-if="item.no > 1 && item.edit_hapus != '0'">
              <a-button type="primary" @click="handleEdit(item)">
                <a-icon type="edit" />
              </a-button>
              <a-button type="danger" @click="handleRemoveDetail(item)">
                <a-icon type="close" />
              </a-button>
            </a-button-group>
          </template>
        </a-table>
        <div class="m-price-total" v-if="loading === false">
          <div class="m-display-flex space-between align-middle">
            <h4>Debit</h4>
            <h3>{{ formatCurrency(mata_uang, debit) }}</h3>
          </div>
          <div class="m-display-flex space-between align-middle">
            <h4>Credit</h4>
            <h3>{{ formatCurrency(mata_uang, kredit) }}</h3>
          </div>
          <a-divider class="margin-small"></a-divider>
          <div class="m-display-flex space-between align-middle">
            <h4>Remaining Balance</h4>
            <h3>{{ formatCurrency(mata_uang, sisa_saldo) }}</h3>
          </div>
        </div>
        <!-- <a-checkbox
          v-if="getScreen"
          v-model="checkCompleted"
          :disabled="
            dataList.length <= 1 && mode === 'Edit' && type === 'revised'
          "
          @change="handleCheckData"
        >Is Data Completed ?</a-checkbox> -->
        <template class="ant-card-actions" slot="actions">
          <!-- <a-button
            type="default"
            :loading="btnLoading"
            @click="savemobile"
            v-if="getScreen"
            :disabled="dataList.length <= 1"
          >{{ status === false ? "Save Draft" : "Save" }}</a-button>
          <div
            class="steps-action"
            v-if="
              !getScreen &&
                (current == steps.length - 1 ||
                  (mode === 'Edit' && type !== 'draft'))
            "
          >
            <a-button
              type="default"
              :loading="btnLoading"
              :disabled="disableSaveButton"
              @click="save"
            >Save</a-button>
            <a-button
              v-if="type !== 'revised'"
              :disabled="disableSaveButton"
              type="default"
              :loading="btnLoading"
              @click="saveDraft"
            >Save Draft</a-button>
          </div> -->
        </template>
      </a-card>
    </a-col>
    <Modal :data="modal.data" :modalEdit="modal.modalEdit" />
    <Collective v-if="isCollective" :close="handleCloseCollective">
      <div slot="title">
        <a-icon type="edit" />&nbsp;Edit Collective
      </div>
      <template slot="content">
        <a-form :form="formCollective">
          <a-form-item label="UM Detail">
            <a-select showSearch allowClear optionFilterProp="children" :filterOption="filterOption"
              @change="handleChangeumDtl" v-decorator="['um_dtl', { rules: [{ required: true }], initialValue: undefined }]">
              <a-select-option v-for="item in ppdetil" :key="item.id_um_dtl">
                <div class="elipsdiv">
                  <div class="elipsdiv-mouseover-label1">{{ item.item_nm }}</div>
                  <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">
                      {{
                        formatCurrency(item.currency, parseFloat(item.saldo_um))
                      }}
                    </b>
                  </div>
                </div>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <a-form-item label="Is Commission?">
                <a-radio-group v-decorator="[
                  'iscommision',
                  { rules: [{ required: false }], initialValue: '0' },
                ]" @change="handleOptionCommission" :disabled="EnCommission" button-style="solid">
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note" > -->
              <a-form-item label="With Note?" :hidden="true">
                <a-radio-group v-decorator="[
                  'without_note',
                  { rules: [{ required: false }], initialValue: '0' },
                ]" button-style="solid">
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-table :columns="columns" :dataSource="getCountWeb" :pagination="paginationCollective" size="small"
          :scroll="{ x: 750 }" bordered style="padding-top:15px;">
          <template slot="customTitle">
            {{this.isCollective ? "Check" : "Action"}}&nbsp;
            <a-checkbox v-model="checkAllCollective" @change="onCheckAllChange">
            </a-checkbox>
          </template>
          <template slot="title" slot-scope="currentPageData">
            <div class="search-wrapper" style="text-align:right">
              <a-input-search
                v-model="searchCollective"
                @change="onSearchCollective"
                placeholder="Search... "
                :style="getScreen ? 'width:100%' : 'width:30%'"
                :loading="timer.loadingcollective"
              >
              </a-input-search>
            </div>
          </template>
          <template slot="deskripsi" slot-scope="index, item">
            <h4 class="margin-remove">{{ item.deskripsi }}</h4>
            <a-alert type="error" banner v-if="item.edit_hapus != '0' && item.kredit != '' && (item.item_um == null
              || item.item_um == '')" message="item name cannot be empty!" />
            <small>{{ item.item_um }}</small>
          </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="commission" slot-scope="index, item">
            <span v-if="item.iscommision == '1'">
              Yes
            </span>
            <span v-else>
              No
            </span>
          </template>
          <template slot="operation" slot-scope="index, item">
            <a-checkbox v-if="item.edit_hapus != '0' && item.kredit"
              :checked="selected.filter(obj => obj.id == item.id).length == 0 ? false : true" @change="handleCheck"
              :value="item" />
          </template>
        </a-table>
      </template>
      <a-button-group slot="action">
        <a-button @click="handleSet" type="primary" :disabled="selected.length == 0">Set</a-button>
        <a-button @click="handleCloseCollective" :type="selected.length == 0 ? 'primary' : ''">Done</a-button>
      </a-button-group>
    </Collective>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Informasi from "./steps/Informasi.vue";
import Pemakaian from "./steps/Pemakaian.vue";
import Approval from "./steps/Persetujuan.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import nanoid from "nanoid";
import Modal from "./Modal.vue";
import moment from "moment";
import Loading from "@/components/preloader/Loading.vue";
import Collective from "@/components/collective/Collective.vue";
import collectiveLapPP from "@/mixins/collective/collectiveLapPP";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "LapUMPPCreate",
  props: ["id", "type"],
  components: {
    Informasi,
    Pemakaian,
    Approval,
    Modal,
    Loading,
    Collective,
  },
  mixins: [CurrencyFormat, collectiveLapPP, GlobalMethod],
  data() {
    return {
      loading: true,
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Pemakaian",
          content: "Pemakaian",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData: {},
      mode: "Create",
      id_lk: nanoid(11),
      active: false,
      status: false,
      dataList: [],
      url: "",
      debit: 0,
      kredit: 0,
      mata_uang: "",
      sisa_saldo: 0,
      pageLoading: true,
      pagination: {
        onChange: (page) => { },
        pageSize: 5,
        size: "small",
      },
      paginationCollective: {
        onChange: (page) => { },
        pageSize: 10,
        size: "small",
      },
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: 0,
          id: "",
        },
      },
      btnLoading: false,
      checkCompleted: false,
      limitasi: 0,
      columns: [],
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingAdd: false,
      EnCommission: true,
      Viwithout_note: true,
      searchCollective:'',
      checkAllCollective: false,
      timer: {
        collective: null,
        loadingcollective: false,
      }
    };
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      if (this.type === "draft") {
        this.url = this.$serviceUrl + "lap_um_pp/detil_pemakaian";
        this.fetchEdit(this.url);
      } else {
        this.url = this.$serviceUrl + "lap_um_pp/revisi_detil_pemakaian";
        this.fetchEdit(this.url);
      }
    } else if (this.mode === "Create") {
      this.url = this.$serviceUrl + "lap_um_pp/detil_pemakaian";
      this.loading = false;
    }

    if (this.id && this.mode === "Edit" && !this.getScreen && this.loading) {
      this.fetchPemakaian();
    }

    if (this.getScreen && this.mode === "Edit" && this.type === "revised") {
      this.checkCompleted = true;
      this.status = true;
    }

    this.columns = [
      {
        title: "No",
        dataIndex: "no",
        key: "no",
        width: 60,
        align: "center",
        sorter: (a, b) => a.no - b.no,
        fixed: "left",
      },
      {
        title: "Date",
        dataIndex: "tanggal",
        width: 110,
        key: "tanggal",
        sorter: (a, b) =>
          new Date(
            moment(a.tanggal, this.getDefaultDateFormat).format(
              this.getStandartFormatDate
            )
          ) -
          new Date(
            moment(b.tanggal, this.getDefaultDateFormat).format(
              this.getStandartFormatDate
            )
          ),
      },
      {
        title: "Description",
        key: "deskripsi",
        scopedSlots: { customRender: "deskripsi" },
        width: 300,
      },
      {
        title: "Document",
        key: "document",
        scopedSlots: { customRender: "document" },
        width: 125,
        align: "center"
      },
      {
        title: "Commission",
        key: "commission",
        scopedSlots: { customRender: "commission" },
        width: 125,
        align: "center"
      },
      {
        title: "Debit",
        dataIndex: "debit_value",
        align: "right",
        key: "debit_value",
        width: 200,
        sorter: (a, b) => a.debit.length - b.debit.length,
      },
      {
        title: "Credit",
        dataIndex: "kredit_value",
        align: "right",
        key: "kredit_value",
        width: 200,
        sorter: (a, b) => a.kredit.length - b.kredit.length,
      },
      {
        title: "Balance",
        dataIndex: "sisa",
        align: "right",
        key: "sisa",
        width: 200,
        sorter: (a, b) => a.sisa.length - b.sisa.length,
      },
      {
        slots: { title: 'customTitle' },
        dataIndex: "operation",
        scopedSlots: { customRender: "operation" },
        width: this.isCollective ? 90 : 110,
        align: "center",
        fixed: "right",
      },
    ];
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getDefaultDateFormat"]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            limitasi: this.limitasi,
            others: this.collectData.others,
            mode: this.mode,
            type: this.type,
            active: this.active,
            sisa_saldo: this.sisa_saldo,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          return {
            data: this.collectData.pemakaian,
            limitasi: this.limitasi,
            informasi: this.collectData.informasi,
            id_lk: this.collectData.others.id_lk,
            mode: this.mode,
            url: this.url,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            type: this.type,
            sisa_saldo: this.sisa_saldo,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      } else {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            limitasi: this.limitasi,
            others: this.collectData.others,
            mode: this.mode,
            active: this.active,
            sisa_saldo: this.sisa_saldo,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          return {
            data: this.collectData.pemakaian,
            limitasi: this.limitasi,
            informasi: this.collectData.informasi,
            id_lk: this.id_lk,
            mode: this.mode,
            url: this.url,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            sisa_saldo: this.sisa_saldo,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Pemakaian") {
        return "refPemakaian";
      } else {
        return "refApproval";
      }
    },
    getCountWeb() {
      let data = this.searchCollective ? 
        _.filter(this.dataList, (e) =>  
          (e.deskripsi && e.deskripsi.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.tanggal && e.tanggal.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) )
        : this.dataList
      let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          // console.log("value.debit", value.debit, value.debit !== "");
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          data[index]["no"] = index + 1;
          data[index]["key"] = index;
          //
          if (value.kredit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.kredit
            );
            debit = debit - value.kredit;
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
          data[index]["edit_hapus"] = value.edit_hapus;
          data[index]["iscommision"] = value.iscommision;
          data[index]["without_note"] = value.without_note;
          data[index]["lampiran"] = value.lampiran;
          data[index]["lampiran_path"] = value.lampiran_path;
        });
      }
      return data;
    },
    disableSaveButton() {
      let result = this.labelExpand == "Collapse";
      if (result) {
        result = true;
      } else {
        result = this.dataList.length < 1;
      }
      return result;
    },
    noAddDatalist() {
      let jml = _.sumBy(this.dataList, function (val) {
        return val.edit_hapus != "0" ? 1 : 0;
      });
      return jml == 0 ? true : false;
    }
  },
  methods: {
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Pemakaian") {
        if (this.noAddDatalist) {
          this.displayMessageValue(
            "error-other",
            "Data Details can't be empty, because this transaction has at least 1 data!"
          );
        } else {
          let exceedDate = _.filter(this.dataList, item => moment(item.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD'))
          if(exceedDate.length>0){
            this.displayMessageValue("error-other", "Usage date can't exceed today!");
            return;
          }
          this.getApproval();
        }
      }
    },
    prev() {
      if (this.steps[this.current].content === "Approval") {
        this.expandcolumn("collapse");
      }
      this.current--;
    },
    savemobile() {
      if (this.status === false) {
        if (this.mode === "Edit" && this.type === "revised") {
          this.save();
        } else {
          this.saveDraft();
        }
      } else {
        this.save();
      }
    },
    save() {
      this.status = true;
      /* Event.$emit("draftStatus", true); */
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    saveDraft() {
      this.status = false;
      this.confirmMessage("confirm-save-draft");
      /* Event.$emit("draftStatus", false); */
    },
    validate() {
      this.$refs.refApproval.handleRef();
      if (
        this.status ||
        (this.status === false &&
          this.type === "revised" &&
          this.mode === "Edit") ||
        (this.status === false &&
          this.type !== undefined &&
          this.mode === "Create")
      ) {
        let postData = new FormData();
        let putData = new FormData();
        let jsonData = {};
        let method = "";
        let link = "";
        this.btnLoading = true;
        if (this.mode === "Edit") {
          link = "/pu/lapmanifestumpp/" + this.collectData.others.id_lk;
          method =
            this.status === true && this.type === "draft" ? "post" : "put";
          putData.append("id_lk", this.id);
          putData.append("tlc", this.getAuth.username);
          putData.append("no_um", this.collectData.informasi.no_um);
          putData.append(
            "tanggal_pelaporan",
            moment(this.collectData.informasi.tanggal_pelaporan).format(
              "YYYY-MM-DD"
            )
          );
          putData.append("public_manifest_url", link);
          putData.append("isparsial", this.collectData.informasi.isparsial);

          jsonData = {
            id_lk: this.id,
            tlc: this.getAuth.username,
            no_um: this.collectData.informasi.no_um,
            tanggal_pelaporan: moment(
              this.collectData.informasi.tanggal_pelaporan
            ).format("YYYY-MM-DD"),
            public_manifest_url: link,
            isparsial: this.collectData.informasi.isparsial,
            catatan: this.collectData.informasi.catatan ?
              this.collectData.informasi.catatan : '',
          };
        } else {
          link = "/pu/lapmanifestumpp/" + this.id_lk;
          method = "post";
          postData.append("id_lk", this.id_lk);
          postData.append("tlc", this.getAuth.username);
          postData.append("no_um", this.collectData.informasi.no_um);
          postData.append(
            "tanggal_pelaporan",
            this.collectData.informasi.tanggal_pelaporan.format("YYYY-MM-DD")
          );
          postData.append("public_manifest_url", link);
          postData.append("isparsial", this.collectData.informasi.isparsial);
          postData.append("catatan", this.collectData.informasi.catatan ?
            this.collectData.informasi.catatan : '');
        }
        axios({
          method: method,
          url: this.$serviceUrl + "lap_um_pp",
          data:
            method === "put"
              ? jsonData
              : this.mode === "Edit"
                ? putData
                : postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            if (this.mode === "Edit") {
              this.displayMessage("success-edit");
            } else {
              this.displayMessage("success-save");
            }
            this.btnLoading = false;
            this.$router.push({ name: "laporanUmpp" });
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            if (responses.message) {
              this.displayMessageValue("error-other", responses.message);
            } else {
              this.displayMessageValue("error", responses);
            }
            this.btnLoading = false;
          });
      } else {
        //if (this.mode === "Edit") {
        axios({
          method: "post",
          url: this.$serviceUrl + "lap_um_pp/draft_parsial",
          data: {
            id_lk: this.id ? this.id : this.id_lk,
            isparsial: this.collectData.informasi.isparsial,
            catatan: this.collectData.informasi.catatan
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(function (response) {
            let responses = Object.assign({}, response.data);
            this.displayMessage("success-other", responses.message);
          })
          .catch(function (response) {
            let responses = Object.assign({}, response.data);
            console.log(responses)
            this.displayMessageValue("error-other", responses);
            console.log(response);
          });
        //} else {
        //  this.displayMessage("success-save");
        //}
        this.$router.push({ name: "laporanUmpp" });
      }
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value;
        this.limitasi = value.limit;
        this.current++;
      } else if (this.steps[this.current].content === "Pemakaian") {
        // this.collectData.persetujuan = JSON.parse(
        //   JSON.stringify(value.persetujuan)
        // );
        //this.save();
        this.current++;
      } else if (this.steps[this.current].content === "Approval") {
        this.collectData.informasi.catatan = value.note;
      }
    },
    controlForm(value) {
      this.active = value;
    },
    draftStatus(val) {
      this.status = val;
    },
    fetchLimitasi() {
      axios({
        method: "get",
        url: this.$serviceUrl + "main/limit_laporan_um",
        params: {
          id_um: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.limitasi = response.data.limit;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
        });
    },
    fetchEdit(url) {
      axios({
        method: "get",
        url: url,
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            detil_pemakaian: response.data.detail_pemakaian,
            informasi: {
              no_um: response.data.no_um,
              tanggal_pelaporan: response.data.tgl_buat,
              bod: response.data.bod,
              id_um: response.data.id_um,
              isparsial: response.data.isparsial,
              catatan: response.data.catatan,
            },
            others: {
              mata_uang: response.data.mata_uang,
              id_lk: response.data.id_lk,
              peruntukan: response.data.peruntukan,
              sisa_saldo: response.data.sisa_saldo,
              total_debit: response.data.total_debit,
              total_kredit: response.data.total_kredit,
            },
          };
          this.id_lk = response.data.id_lk;
          this.loading = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
          this.$router.go(-1);
        });
    },
    async fetchPemakaian() {
      let id_lk = "";
      this.loadingAdd = true;
      if (this.mode == "Edit") {
        id_lk = this.id;
      } else if (this.mode === "Create") {
        id_lk = this.collectData.informasi.no_um;
      }

      if (!this.getScreen) {
        await axios({
          method: "get",
          url: this.url,
          params: {
            tlc: this.getAuth.username,
            id_lk: id_lk,
            mode: this.mode,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataList = response.data.detail_pemakaian;
            this.debit = response.data.total_debit;
            this.kredit = response.data.total_kredit;
            this.sisa_saldo = response.data.sisa_saldo;
            this.mata_uang = response.data.mata_uang;
            if (this.$refs.refPemakaian) {
              this.$refs.refPemakaian.done();
            }
            if (this.dataList.length === 1) {
              this.active = false;
            }
            this.loadingAdd = false;
          })
          .catch((err) => {
            console.log(err);
            if (
              err.response.data.message === "Tidak Memiliki Detil Pemakaian"
            ) {
              this.displayMessage("no-detil-PP");
              this.active = false;
              this.mode = "Create";
              this.dataList = [];
              this.collectData = {};
              this.debit = 0;
              this.sisa_saldo = 0;
              this.kredit = 0;
              this.$router.push({ name: "lapUmppCreate" });
            }
            this.$refs.refPemakaian.done();
            this.loading = false;
            this.loadingAdd = false;
          });
      } else {
        if (this.steps[this.current].content === "Pemakaian") {
          await axios({
            method: "get",
            url: this.url,
            params: {
              tlc: this.getAuth.username,
              id_lk: id_lk,
              mode: this.mode,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.dataList = response.data.detail_pemakaian;
              this.debit = response.data.total_debit;
              this.kredit = response.data.total_kredit;
              this.sisa_saldo = response.data.sisa_saldo;
              this.mata_uang = response.data.mata_uang;
              this.$refs.refPemakaian.done();
              if (this.dataList.length === 1) {
                this.active = false;
              }
              this.loadingAdd = false;
            })
            .catch((err) => {
              console.log(err.response);
              if (
                err.response.data.message === "Tidak Memiliki Detil Pemakaian"
              ) {
                this.displayMessage("no-detil-PP");
                this.current = 0;
                this.active = false;
                this.mode = "Create";
                this.collectData = {};
                this.$router.push({ name: "lapUmppCreate" });
                this.$refs.refPemakaian.done();
              }
              this.loading = false;
              this.loadingAdd = false;
            });
        }
      }
      if (this.$refs.refPemakaian) {
        this.$refs.refPemakaian.fetchAttribute();
      }
    },
    handleCheckData(e) {
      this.draftStatus(e.target.checked);
    },
    handleNew() {
      this.$refs.refPemakaian.handleNew();
    },
    handleEdit(item) {
      this.modal.data = { pageloading: true };
      this.handleFetchEdit(item).then(async (result) => {
        this.modal.data = {
          ppdetillist: result.data.list_dtl_um,
          selected_um_dtl: result.data.selected_um_dtl,
          tanggal_pemakaian: item.tanggal_pemakaian,
          deskripsi: item.deskripsi,
          kredit: item.kredit,
          id: item.id,
          um_dtl: item.id_um_dtl,
          type: this.id ? (this.type === "draft" ? "edit" : "revised") : "edit",
          typeEdit: this.type,
          debit: this.debit,
          limitasi: this.limitasi,
          mata_uang: this.mata_uang,
          totalKreditSebelum: this.kredit,
          pageloading: false,
          iscommision: item.iscommision ? item.iscommision : "0",
          without_note: item.without_note ? item.without_note : "1",
        };

        if (!item.iscommision) {
          this.modal.data.EnCommission = false;
          this.modal.data.Viwithout_note = true;
        } else if (item.iscommision == "1" && result.data.iscommision_ori) {
          this.modal.data.EnCommission = true;
          this.modal.data.Viwithout_note = false;
        } else if (item.iscommision == "1" && !result.data.iscommision_ori) {
          this.modal.data.EnCommission = false;
          this.modal.data.Viwithout_note = false;
        } else {
          this.modal.data.iscommision == "0";
          this.modal.data.EnCommission = false;
          this.modal.data.Viwithout_note = true;
        }

        if (result.data.lampiran) {
          let typefile = this.fileTypeFromUrl(result.data.lampiran);
          let file = this.dataURLtoFile(
            typefile + result.data.lampiran_file,
            result.data.lampiran
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + result.data.lampiran_path;
          this.modal.data.doctransfiles = [];
          this.modal.data.doctransfiles.push(file);
        }
      });
      this.modal.modalEdit = true;
    },
    async handleFetchEdit(item) {
      const url =
        this.type == "draft" || this.type == undefined
          ? "lap_um_pp/detil_pemakaian_update"
          : "lap_um_pp/revisi_detil_pemakaian_update";
      return await axios({
        method: "get",
        url: this.$serviceUrl + url,
        params: {
          id_dtl_lk: item.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleCancel(e) {
      this.modal.modalEdit = false;
    },
    handleRemoveDetail(item) {
      if (this.dataList.length == 2) {
        this.displayMessageValue("delete-cancel", null);
      } else {
        this.confirmMessageValue("confirm-delete", item);
      }
    },
    async delete(item) {
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };

      const url =
        serviceUrl +
        (this.mode === "Create"
          ? "lap_um_pp/detil_pemakaian"
          : this.type === "Draft"
            ? "lap_um_pp/revisi_detil_pemakaian"
            : this.type === "revised"
              ? "lap_um_pp/revisi_detil_pemakaian"
              : "lap_um_pp/detil_pemakaian");

      await axios({
        method: "delete",
        url: url,
        processData: false,
        data: {
          id: item.id,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.fetchPemakaian();
          if (this.dataList.length < 3) {
            if (this.current > 0) {
              this.current = this.current - 1;
              this.active = false;
            }
            this.$refs.refInformasi.fetchUmPP();
            this.$router.push({ path: "/laporan/umpp/create" });
          }
          this.displayMessage("success-del");
          this.handleCancel();
          if (this.$refs.refPemakaian) {
            this.$refs.refPemakaian.fetchAttribute();
          }
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    switchMode(value) {
      this.mode = value;
    },
    messagelimit(val) {
      this.displayMessageValue(
        "limit-lap",
        this.formatCurrency(val.mata_uang, val.limitasi)
      );
    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        this.pagination.pageSize = 5;
      }
    },
    handleLoading(value) {
      this.loadingAdd = value;
    },
    async getApproval() {
      let params = {
        tlc: this.getAuth.username,
        no_um: this.collectData.informasi.no_um,
        id_lk_um: this.type == 'draft' ? this.id : this.id_lk,
        is_parsial: this.collectData.informasi.isparsial,
        is_draft: this.type == 'revised' ? 0 : 1,
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "lap_um_pp/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval = response.data.data;
          this.expandcolumn("expand");
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    expandcolumn(val) {
      if (val == "expand") {
        this.leftcolumn = 24;
        this.rightcolumn = 0;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
      }
    },
    handleOptionCommission(val) {
      if (val.target.value == "1") {
        this.Viwithout_note = false;
      } else {
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.formCollective.setFieldsValue({
          without_note: "0",
        });
      });
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    onSearchCollective(){
      if (this.timer.collective) {
        clearTimeout(this.timer.collective);
        this.timer.collective = null;
      }
        this.timer.collective = setTimeout(() => {
          this.timer.loading = true;
          this.checkAllCollective = false;
          this.timer.loading = false;
      }, 600);
    },
    onCheckAllChange(val){
      this.getCountWeb.forEach((element) => {
        if(element.edit_hapus!='0'){
          let index = _.findIndex(
            this.selected,
            (e) => {
              return e.id == element.id;
            }
          );

          if(val.target.checked){
            if(index < 0){
              this.selected.push(element)
            }
          }else{
            if(index >= 0){
              this.selected = _.filter(this.selected, (e) => e.id!=element.id)
            }
          }
        }
      })
    }
  },
  mounted() {
    this.fetchLimitasi();
    Event.$on("lapUmpp", this.valueFromChild);
    Event.$on("disableInformasi", this.controlForm);
    Event.$on("draftStatus", this.draftStatus);
    Event.$on("fetchPemakaian", this.fetchPemakaian);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("removeDetail", this.handleRemoveDetail);
    Event.$on("switchMode", this.switchMode);
    Event.$on("confirmMessageReturn", this.validate);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("messagelimit", this.messagelimit);
    Event.$on("handleLoading", this.handleLoading);
    Event.$on("ismobileSaveLapumpp", this.handleCheckData);
  },
  beforeDestroy() {
    Event.$off("lapUmpp", this.valueFromChild);
    Event.$off("disableInformasi", this.controlForm);
    Event.$off("draftStatus", this.draftStatus);
    Event.$off("fetchPemakaian", this.fetchPemakaian);
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("removeDetail", this.handleRemoveDetail);
    Event.$off("confirmMessageReturn", this.validate);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("messagelimit", this.messagelimit);
    Event.$off("ismobileSaveLapumpp", this.handleCheckData);
  },
};
</script>

<style></style>
